export const questions: Array<[string, string]> = [
  [
    'Who is it for?',
    'Electrical engineers, protection and control technicians, substation operators, electricians moving into high-voltage work, and students who work in or want to move into substations and power systems.',
  ],
  ['Content depth?', 'From fundamentals to professional-level protection, automation, testing and maintenance.'],
  [
    'International?',
    'Yes. Based on internationally used concepts and terminology (IEC and IEEE); always follow local codes, utility procedures and manufacturer instructions.',
  ],
  ['Format?', 'Professional PDF files with instant access.'],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  ['Not satisfied?', '7-day refund. 100% money back.'],
];
